function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.26849 24.5906L13.1343 26L10.3155 30.2282L3.26849 28.5369V24.5906Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.26849 36.4296V39.5303C3.26849 40.3759 3.83225 40.9397 4.67789 41.0806L10.1745 41.5034C11.0202 41.5034 11.7249 40.9397 11.7249 39.9531V38.6847",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M42.7316 24.5906L32.8658 26L35.6846 30.2282L42.7316 28.5369V24.5906Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7852 26.2819L13.1342 26.0001",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M32.8658 26.0001L27.2282 26.4229",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M35.6846 30.2283L34.2752 31.6377C26.8054 32.6242 19.1946 32.6242 11.7248 31.6377L10.3154 30.2283",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0671 22.4765L4.67789 21.7719L3.26849 24.5906",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M42.7315 24.5906L41.3221 21.7719L26.9463 22.4765",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M13.698 10.3558H12.8524C11.302 10.3558 9.89262 11.2014 9.18792 12.6108L4.67786 21.7719",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M41.3222 21.7719L36.8121 12.6108C36.1074 11.2014 34.698 10.3558 33.1477 10.3558H32.1611",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M42.7315 28.537L43.4362 29.3826C43.8591 29.9464 44 30.5101 44 31.2148V34.8793C44 35.584 43.5772 36.2887 42.8725 36.4296L35.6846 38.4028L30.4698 38.9665C25.5369 39.5303 20.4631 39.5303 15.5302 38.9665L10.3154 38.4028L3.12752 36.4296C2.42282 36.2887 2 35.584 2 34.8793V31.2148C2 30.5101 2.28188 29.9464 2.56376 29.3826L3.26846 28.537",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M42.7316 36.4296V39.5303C42.7316 40.3759 42.1678 40.9397 41.3222 41.0806L35.8255 41.5034C34.9799 41.5034 34.2752 40.9397 34.2752 39.9531V38.6847",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5772 24.3087C21.4497 24.3087 20.4631 25.2953 20.4631 26.4228C20.4631 27.5503 21.4497 28.5369 22.5772 28.5369C23.7047 28.5369 24.6913 27.5503 24.6913 26.4228C24.6913 25.2953 23.7047 24.3087 22.5772 24.3087Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M22.859 5C20.4631 5 17.9262 6.12752 16.7986 8.66443C16.2349 9.93289 17.2215 11.3423 18.6309 11.3423C19.3355 11.3423 20.0402 10.9195 20.3221 10.2148C20.7449 9.22819 21.7315 8.80537 22.7181 8.80537C24.1275 8.80537 25.255 9.79195 25.255 11.3423C25.255 12.7517 24.4094 13.4564 23.2819 14.1611C22.0134 15.1477 20.4631 16.1342 20.4631 19.094V19.3758C20.4631 20.5034 21.3087 21.349 22.4362 21.349C23.5637 21.349 24.4094 20.5034 24.4094 19.3758V19.094C24.4094 17.6846 25.396 16.8389 26.3825 16.1342C27.651 15.1477 29.0604 14.0201 29.0604 11.3423C29.3423 7.25503 26.1007 5 22.859 5Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgVehicleNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleNotFound);
export default __webpack_public_path__ + "static/media/vehicle-not-found.cbd78ebc7c6e0efdc3f3ae149f4b14dd.svg";
export { ForwardRef as ReactComponent };